// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fill-table-card {
  min-width: 600px;
  margin-bottom: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
}

.fill-table-card .card-header {
  padding: 15px 20px;
  background-color: #f5f7fa;
  border-bottom: 1px solid #e1e8ed;
}

.fill-table-card .card-content {
  padding: 20px;
}

.fill-table-card button {
  min-width: 100px !important;
  width: auto !important;
  padding: 8px 24px !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/selfService/FillTableCard.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,wCAAwC;EACxC,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,2BAA2B;EAC3B,sBAAsB;EACtB,4BAA4B;AAC9B","sourcesContent":[".fill-table-card {\n  min-width: 600px;\n  margin-bottom: 20px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  border-radius: 8px;\n}\n\n.fill-table-card .card-header {\n  padding: 15px 20px;\n  background-color: #f5f7fa;\n  border-bottom: 1px solid #e1e8ed;\n}\n\n.fill-table-card .card-content {\n  padding: 20px;\n}\n\n.fill-table-card button {\n  min-width: 100px !important;\n  width: auto !important;\n  padding: 8px 24px !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
